export const isDateValid = (date: string): boolean => {
  return !isNaN(+new Date(date));
};
